import { render, staticRenderFns } from "./Favourites.vue?vue&type=template&id=fbed8cc4&"
import script from "./Favourites.vue?vue&type=script&lang=js&"
export * from "./Favourites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fbed8cc4', component.options)
    } else {
      api.reload('fbed8cc4', component.options)
    }
    module.hot.accept("./Favourites.vue?vue&type=template&id=fbed8cc4&", function () {
      api.rerender('fbed8cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Favourites.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Favourites.vue
// module id = 165
// module chunks = 6